import moment from 'moment'
import { getTypeOfValueByQueryType } from './helper'
import { modules, notPublishedEnvObj } from './constant'

const buildInQueryForCt = (ctQueryArray, queryObj) => {
  let valuesArray = []
  ctQueryArray.forEach((query) => {
    const { value, key, operator } = query
    if (Array.isArray(value) && value.length) {
      valuesArray.push(value[0].value)
    }
  })
  if (valuesArray.length) {
    queryObj['_content_type_uid'] = { $in: valuesArray }
  }
}

const buildQueryForContentType = (value, operator, queryObj) => {
  if (value[0].type === 'text') {
    if (operator[0].value === '$ne') {
      queryObj.$and.push({ _content_type_uid: { $ne: value[0].value } })
    } else {
      queryObj.$and.push({ _content_type_uid: { $regex: value[0].value } })
    }
  } else {
    if (operator[0].value === 'contains') {
      queryObj.$and.push({ _content_type_uid: { $regex: value[0].value } })
    } else {
      queryObj.$and.push({ _content_type_uid: { [operator[0].value]: value[0].value } })
    }
  }
}

const checkForNonEqualOperator = (ctQueryArray) => {
  const foundCt = ctQueryArray.find((query) => {
    const { key = [], value = [], operator = [] } = query
    return operator[0]?.value !== '$eq'
  })
  return foundCt
}

export const queryBuilderEntries = ({ queryArray, isAssetManagerV2InCMS, isAssetManagerV2 }) => {
  // debugger
  let queryObj: any = { $and: [] }
  
  const environmentKey = (isAssetManagerV2InCMS || isAssetManagerV2) ? 'publish_details.environment' : '_publish_environment'

  let [ctQueryArray, publishedEnvEqualQuery, filteredQueryArray] = queryArray.reduce(
    ([ctQueryArray, publishedEnvEqualQuery, filteredQueryArray], query) => {
      const { key = [], operator = [], value = [] } = query
      if (key[0]?.value === '_content_type_uid') {
        return [[...ctQueryArray, query], publishedEnvEqualQuery, filteredQueryArray]
      }

      if (
        key[0]?.value === '_publish_environment' &&
        (operator[0]?.value === '$eq' || (operator[0]?.value === '$ne' && value[0]?.value === '_notPublished_env'))
      ) {
        return [ctQueryArray, [...publishedEnvEqualQuery, query], filteredQueryArray]
      }

      return [ctQueryArray, publishedEnvEqualQuery, [...filteredQueryArray, query]]
    },
    [[], [], []]
  )

  if (ctQueryArray.length) {
    ctQueryArray.forEach((query) => {
      const { key = [], operator = [], value = [] } = query
      if (key.length && operator.length && value.length) {
        buildQueryForContentType(value, operator, queryObj)
      }
    })
    //todo multict query test
    // if (!checkForNonEqualOperator(ctQueryArray)) {
    //   buildInQueryForCt(ctQueryArray, queryObj)
    // } else {
    // }
  }

  // console.log('queryObj', queryObj, checkForNonEqualOperator(ctQueryArray))

  if (publishedEnvEqualQuery.length) {
    let notPubEnvCaseCheck = false
    let notPubOperator = ''

    publishedEnvEqualQuery = publishedEnvEqualQuery.filter((query) => {
      const { value = [], operator = [] } = query
      if (value.length && value[0].value === notPublishedEnvObj.value) {
        notPubEnvCaseCheck = true
        notPubOperator = operator[0]?.value
        return false
      }
      return true
    })

    const allEnvs = publishedEnvEqualQuery.map((query) => query.value[0].value)

    if (notPubEnvCaseCheck) {
      let notPubExistValue = notPubOperator !== '$eq'
      const notPubQuery: any = { $or: [{ _publish_details: { $exists: notPubExistValue } }] }

      if (allEnvs.length) {
        notPubQuery.$or.push({ [environmentKey]: { $in: allEnvs } })
      }
      queryObj.$and.push(notPubQuery)
    } else if (allEnvs.length) {
      queryObj.$and.push({ [environmentKey]: { $in: allEnvs } })
    }
  }

  //creating query for all remaining query object
  filteredQueryArray.forEach((query, index) => {
    const { key = [], operator = [], value = [], queryType } = query
    if (key.length && operator.length && value.length && query.queryType !== 'localizedInLabel') {
      if (getTypeOfValueByQueryType(queryType) === 'number') {
        const controlledValue = operator[0].value === '$exists' ? value[0].value : parseInt(value[0].value)
        let query = { [key[0].value]: { [operator[0].value]: controlledValue } }
        queryObj.$and.push(query)
      } else if (queryType === 'environmentLabel') {
        const envOpsMapping = {
          $eq: '$in',
          $ne: '$nin'
        }
        const env_operator = envOpsMapping[operator[0].value]
        const envKey = (key[0].value === '_publish_environment' && (isAssetManagerV2InCMS || isAssetManagerV2)) 
          ? 'publish_details.environment' 
          : key[0].value
        queryObj.$and.push({ [envKey]: { [env_operator]: [value[0].value] } })
      } else if (queryType === 'dateLabel') {
        if (operator[0].value === '$eq') {
          // let dateInIso = moment(value[0].value).toISOString()
          // let dateQuery = { [key[0].value]: { $eq: dateInIso } }
          // queryObj.$and.push(dateQuery)

          let startTime = moment(value[0].value).startOf('day').toISOString()
          let endTime = moment(value[0].value).endOf('day').toISOString()
          let startTimeQuery = { [key[0].value]: { $gte: startTime } }
          let endTimeQuery = { [key[0].value]: { $lte: endTime } }
          queryObj.$and.push(startTimeQuery)
          queryObj.$and.push(endTimeQuery)
        } else if (operator[0].value === '$lte') {
          let startTime = moment(value[0].value).endOf('day').toISOString()

          let query = { [key[0].value]: { [operator[0].value]: startTime } }
          queryObj.$and.push(query)
        } else if (operator[0].value === '$exists') {
          let query = { [key[0].value]: { [operator[0].value]: value[0].value } }
          queryObj.$and.push(query)
          console.log('updateAdvancedQueryArray -> currentQuery dateLabel 2222', queryObj)
        } else {
          let startTime = moment(value[0].value).startOf('day').toISOString()

          let query = { [key[0].value]: { [operator[0].value]: startTime } }
          queryObj.$and.push(query)
        }
      } else if (queryType === 'languageLabel') {
        let query = { [key[0].value]: { [operator[0].value]: value[0].value } }

        const localizeQuery = filteredQueryArray[index + 1]
        if (localizeQuery && localizeQuery.queryType === 'localizedInLabel') {
          const localizeKey = localizeQuery.key[0]
          const value = (localizeQuery.value[0] && localizeQuery.value[0].value) || []
          const localizedIds = value.map((v) => v.value)
          if (!localizedIds.includes('$any')) {
            const operatorValue = localizeQuery.operator[0].value === '$localization' ? '$in' : '$nin'
            query[key[0].value][localizeKey.value] = { [operatorValue]: localizedIds }
          }
        }
        queryObj.$and.push(query)
      } else if (queryType === 'booleanLabel' && key[0]?.value === '_is_draft') {
        const normalizedValue = value[0].value === 'true' || value[0].value === true
        let query = { [key[0].value]: { [operator[0].value]: normalizedValue } }
        queryObj.$and.push(query)
      } else if (queryType === 'referenceLabel') {
        let query: any = { [key[0].value]: { [operator[0].value]: value[0].value } }
        query.contentTypeUid = value[0].ctUid
        queryObj.$and.push(query)
      } else if (operator[0].value !== 'contains') {
        let query = { [key[0].value]: { [operator[0].value]: value[0].value } }
        queryObj.$and.push(query)
      } else if (operator[0].value === 'contains') {
        let query: any = { [key[0].value]: { $regex: value[0].value } }
        if (queryType === 'customFieldJsonLabel') {
          query = { [key[0].value]: { $regex: value[0].value, isJsonCustomField: true } }
        }
        queryObj.$and.push(query)
      }
    }
  })

  if (!queryObj.$and.length) {
    const { $and, ...rest } = queryObj
    queryObj = rest
  }

  return { queryObject: !queryObj.$and && !queryObj._content_type_uid ? '' : queryObj }
}

export const queryBuilderAssets = ({ queryArray, isAssetManagerV2InCMS, isAssetManagerV2 }) => {
  let queryObj = { $and: [] }
  
  const environmentKey = (isAssetManagerV2InCMS || isAssetManagerV2) ? 'publish_details.environment' : '_publish_environment'

  let [publishedEnvEqualQuery, filteredQueryArray] = queryArray.reduce(
    ([publishedEnvEqualQuery, filteredQueryArray], query) => {
      const { key = [], operator = [], value = [] } = query
      if (
        key[0]?.value === '_publish_environment' &&
        (operator[0]?.value === '$eq' || (operator[0]?.value === '$ne' && value[0]?.value === '_notPublished_env'))
      ) {
        return [[...publishedEnvEqualQuery, query], filteredQueryArray]
      }

      return [publishedEnvEqualQuery, [...filteredQueryArray, query]]
    },
    [[], []]
  )

  if (publishedEnvEqualQuery.length) {
    let notPubEnvCaseCheck = false
    let notPubOperator = ''

    publishedEnvEqualQuery = publishedEnvEqualQuery.filter((query) => {
      const { value = [], operator = [] } = query
      if (value.length && value[0].value === notPublishedEnvObj.value) {
        notPubEnvCaseCheck = true
        notPubOperator = operator[0]?.value
        return false
      }
      return true
    })

    const allEnvs = publishedEnvEqualQuery.map((query) => query.value[0].value)

    if (notPubEnvCaseCheck) {
      let notPubExistValue = notPubOperator !== '$eq'
      const notPubQuery: any = { $or: [{ _publish_details: { $exists: notPubExistValue } }] }

      if (allEnvs.length) {
        notPubQuery.$or.push({ [environmentKey]: { $in: allEnvs } })
      }
      queryObj.$and.push(notPubQuery)
    } else if (allEnvs.length) {
      queryObj.$and.push({ [environmentKey]: { $in: allEnvs } })
    }
  }

  filteredQueryArray.forEach((query) => {
    const { key = [], operator = [], value = [], queryType } = query

    if (key.length && operator.length && value.length) {
      if (queryType === 'environmentLabel') {
        const envOpsMapping = {
          $eq: '$in',
          $ne: '$nin'
        }
        const env_operator = envOpsMapping[operator[0].value]
        const envKey = (key[0].value === '_publish_environment' && (isAssetManagerV2InCMS || isAssetManagerV2)) 
          ? 'publish_details.environment' 
          : key[0].value
        queryObj.$and.push({ [envKey]: { [env_operator]: [value[0].value] } })
      } else if (queryType === 'dateLabel') {
        // console.log('date string', value)
        if (operator[0].value === '$eq') {
          // let dateInIso = moment(value[0].value).toISOString()
          // let dateQuery = { [key[0].value]: { $eq: dateInIso } }
          // queryObj.$and.push(dateQuery)

          let startTime = moment(value[0].value).startOf('day').toISOString()
          let endTime = moment(value[0].value).endOf('day').toISOString()
          let startTimeQuery = { [key[0].value]: { $gte: startTime } }
          let endTimeQuery = { [key[0].value]: { $lte: endTime } }
          queryObj.$and.push(startTimeQuery)
          queryObj.$and.push(endTimeQuery)
        } else if (operator[0].value === '$lte') {
          let startTime = moment(value[0].value).endOf('day').toISOString()
          let query = { [key[0].value]: { [operator[0].value]: startTime } }
          queryObj.$and.push(query)
        } else {
          let startTime = moment(value[0].value).startOf('day').toISOString()

          let query = { [key[0].value]: { [operator[0].value]: startTime } }
          queryObj.$and.push(query)
        }
      } else if (queryType === 'languageLabel') {
        let query = { [key[0].value]: { [operator[0].value]: value[0].value } }
        queryObj.$and.push(query)
      } else if (operator[0].value !== 'contains') {
        let query = { [key[0].value]: { [operator[0].value]: value[0].value } }
        queryObj.$and.push(query)
      } else if (operator[0].value === 'contains') {
        let query = { [key[0].value]: { $regex: value[0].value } }
        queryObj.$and.push(query)
      }
    }
  })
  return { queryObject: queryObj.$and.length ? queryObj : '' }
}

let isCtFoundInParent = false
const buildQueryObject = (advanceQueryArray, nestedArray, selectedModule, isAssetManagerV2InCMS, isAssetManagerV2) => {
  for (let queryObject of advanceQueryArray) {
    const operator = queryObject.queryType === 'matchAll' ? '$and' : '$or'
    const queryArray = queryObject.queryArray

    const foundCtType = queryArray.find((query) => query.key[0].value === '_content_type_uid')
    // console.log('buildQueryObject -> foundCtType', foundCtType)
    if (foundCtType) {
      isCtFoundInParent = true
    }
    let newArray = []
    let currentQueryObject = { [operator]: newArray }
    nestedArray.push(currentQueryObject)

    let queryBuilderForModule: any

    if (selectedModule === modules[0].value) {
      queryBuilderForModule = queryBuilderEntries
    } else if (selectedModule === modules[1].value) {
      queryBuilderForModule = queryBuilderAssets
    }

    const queryBuilderResult: any = queryBuilderForModule({ queryArray, queryCase: 'advanceQuery', isAssetManagerV2InCMS, isAssetManagerV2 })
    const { queryObject: { $and = [], ...rest } = {} } = queryBuilderResult

    const queryObjectForQueryArray = queryBuilderResult?.queryObject?.$and || []
    queryObjectForQueryArray.forEach((query) => {
      newArray.push(query)
    })

    //inserting any other key thann and array
    const keyArray = Object.keys(rest)
    if (keyArray.length) {
      keyArray.forEach((key) => {
        currentQueryObject[key] = rest[key]
        // if (!(key === '_content_type_uid' && isCtFoundInParent)) {
        // }
      })
    }

    if (queryObject.children.length) {
      buildQueryObject(queryObject.children, newArray, selectedModule, isAssetManagerV2InCMS, isAssetManagerV2)
    }
  }
}

export const buildQueryObjectForAdvCase = (advanceQueryArray, selectedModule, isAssetManagerV2InCMS, isAssetManagerV2) => {
  let queryObjectsForAdvQuery = []
  isCtFoundInParent = false

  buildQueryObject(advanceQueryArray, queryObjectsForAdvQuery, selectedModule, isAssetManagerV2InCMS, isAssetManagerV2)
  return queryObjectsForAdvQuery[0]
}
